'use client';

import { useProfile } from '@/src/hooks/use-profile';
import { HeaderActions } from '../ui';
import { ButtonsBlock } from '@/src/sections/home/components/ButtonsBlock';

export const HeaderNav = () => {
  const { data: profile, isLoading } = useProfile();

  if (isLoading) return <HeaderNavSkeleton />;

  const isAnonymous = profile?.type === 'anonymous';

  return (
    <>
      {!isAnonymous ? (
        <HeaderActions profile={profile} />
      ) : (
        <ButtonsBlock isAnonymous />
      )}
    </>
  );
};

export function HeaderNavSkeleton() {
  return (
    <div className="flex items-center md:gap-4 gap-0 md:h-10">
      <div className="hidden md:block h-10 w-[120px] rounded-md bg-gray-200 animate-pulse" />
      <div className="hidden md:block h-10 w-10 rounded-md bg-gray-200 animate-pulse" />
      <div className="h-10 w-10 rounded-md bg-gray-200 animate-pulse" />
    </div>
  );
}


